@if (isGridRequired) {
  <div>
    <irb-inventory-grid
      [gridOptions]="exportOptions.gridOptions"
      (gridReady)="onGridReady($event)"
      [rowData]="rowData"
    ></irb-inventory-grid>
  </div>
}
